import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=4c74502b&scoped=true&"
import script from "./Scope.vue?vue&type=script&lang=js&"
export * from "./Scope.vue?vue&type=script&lang=js&"
import style0 from "./Scope.vue?vue&type=style&index=0&id=4c74502b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/poi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74502b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/yanick/work/javascript/vue-svg-pan-zoom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c74502b')) {
      api.createRecord('4c74502b', component.options)
    } else {
      api.reload('4c74502b', component.options)
    }
    module.hot.accept("./Scope.vue?vue&type=template&id=4c74502b&scoped=true&", function () {
      api.rerender('4c74502b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Scope.vue"
export default component.exports